"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLocationName = createLocationName;
exports.createVariationShortDescription = createVariationShortDescription;
exports.filterBookingInteractions = filterBookingInteractions;
exports.generateDefaultHeadshotAltText = generateDefaultHeadshotAltText;
exports.getBookNowPage = getBookNowPage;
exports.getBusinessFile = getBusinessFile;
exports.getBusinessFiles = getBusinessFiles;
exports.getCategoryItems = getCategoryItems;
exports.getComponentContentNodeContent = getComponentContentNodeContent;
exports.getCtaInteractions = getCtaInteractions;
exports.getFirstBusinessFile = getFirstBusinessFile;
exports.getId = getId;
exports.getLocationTeamMembers = getLocationTeamMembers;
exports.getOtherCategoryItems = getOtherCategoryItems;
exports.getOtherLocations = getOtherLocations;
exports.getPageByType = getPageByType;
exports.getRelatedCategories = getRelatedCategories;
exports.getRelatedServicesForLocation = getRelatedServicesForLocation;
exports.getServiceItemModifierSets = getServiceItemModifierSets;
exports.getServiceTeamMembers = getServiceTeamMembers;
exports.getTeamMemberServices = getTeamMemberServices;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _groupBy2 = _interopRequireDefault(require("lodash/groupBy"));
var _head3 = _interopRequireDefault(require("lodash/head"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _constants = require("./constants");
var _excluded = ["_id", "description", "gatsbyFile", "file"],
  _excluded2 = ["variations", "visible"],
  _excluded3 = ["items"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var EXTERNAL_CLICK_THROUGH_INTERACTION_TYPE = 'EXT_THRU';
function getPageByType() {
  var pages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var targetPageType = arguments.length > 1 ? arguments[1] : undefined;
  return pages.find(function (_ref) {
    var pageType = _ref.pageType;
    return pageType === targetPageType;
  });
}
function getId() {
  var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _get2["default"])(entity, '_id') || (0, _get2["default"])(entity, 'id');
}
function generateDefaultHeadshotAltText(artistName, businessName) {
  return "Portrait of ".concat(artistName, ", a professional stylist at ").concat(businessName, ", showcasing their expertise and style.");
}
function getBookNowPage() {
  var pages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var regex = /book\s*now|schedule\s*appointment|reserve\s*time/i;
  return pages.find(function (_ref2) {
    var title = _ref2.title,
      pageType = _ref2.pageType;
    return regex.test(title) && pageType === 'External';
  });
}
function getCategoryItems(category) {
  var allItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var _ref3 = category || {},
    categoryId = _ref3._id,
    categoryItemIds = _ref3.items;
  return categoryItemIds.filter(function (_ref4) {
    var aCategoryId = _ref4._id;
    return aCategoryId !== categoryId;
  }).map(function (categoryItemId) {
    return allItems.find(function (_ref5) {
      var _id = _ref5._id;
      return _id === categoryItemId;
    });
  }).filter(Boolean);
}
function getOtherCategoryItems(itemId, itemCategory, allItems) {
  if (!itemCategory) {
    return [];
  }
  var _ref6 = itemCategory || {},
    _ref6$items = _ref6.items,
    itemIds = _ref6$items === void 0 ? [] : _ref6$items;
  var otherItemIds = itemIds.filter(function (currentItemId) {
    return currentItemId !== itemId;
  });
  return allItems.filter(function (_ref7) {
    var currentItemId = _ref7._id;
    return otherItemIds.includes(currentItemId);
  }).filter(function (_ref8) {
    var visible = _ref8.visible;
    return !!visible;
  });
}
function getRelatedCategories(category) {
  var allCategories = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var _ref9 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref9$showAllRelatedS = _ref9.showAllRelatedServices,
    showAllRelatedServices = _ref9$showAllRelatedS === void 0 ? false : _ref9$showAllRelatedS;
  var _ref10 = category || {},
    categoryId = _ref10._id,
    _ref10$schedule = _ref10.schedule,
    schedule = _ref10$schedule === void 0 ? {} : _ref10$schedule;
  var _ref11 = schedule || {},
    scheduleId = _ref11._id;
  return allCategories.filter(function (_ref12) {
    var otherCategoryId = _ref12._id,
      _ref12$schedule = _ref12.schedule,
      otherCategorySchedule = _ref12$schedule === void 0 ? {} : _ref12$schedule;
    if (otherCategoryId === categoryId) {
      return false;
    }
    var _ref13 = otherCategorySchedule || {},
      otherCategoryScheduleId = _ref13._id;
    if (showAllRelatedServices) {
      return true;
    }
    return otherCategoryScheduleId === scheduleId;
  });
}
function getBusinessFiles(businessFileIds) {
  var businessFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return (businessFileIds || []).map(function (objectFileId) {
    var file = businessFiles.find(function (_ref14) {
      var _id = _ref14._id;
      return _id === objectFileId || _id === (0, _get2["default"])(objectFileId, '_id');
    });
    if (file) {
      var _id = file._id,
        description = file.description,
        gatsbyFile = file.gatsbyFile,
        fileUrl = file.file,
        restFile = (0, _objectWithoutProperties2["default"])(file, _excluded);
      return _objectSpread(_objectSpread({}, restFile), {}, {
        _id: _id,
        fileUrl: fileUrl,
        gatsbyFile: gatsbyFile,
        src: gatsbyFile || fileUrl,
        altText: description || '',
        url: fileUrl
      });
    }
    return false;
  }).filter(Boolean);
}
function getBusinessFile(businessFileId) {
  var businessFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var files = getBusinessFiles([businessFileId], businessFiles);
  if (!(0, _isEmpty2["default"])(files)) {
    return files[0];
  }
  return null;
}
function getFirstBusinessFile(businessFileIds) {
  var businessFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var objectFiles = getBusinessFiles(businessFileIds, businessFiles);
  if ((0, _isEmpty2["default"])(objectFiles)) {
    return null;
  }
  return objectFiles[0];
}
function getCtaInteractions(interactions) {
  return (interactions || []).filter(function (_ref15) {
    var behaviorType = _ref15.behaviorType,
      enabled = _ref15.enabled;
    return enabled && behaviorType !== EXTERNAL_CLICK_THROUGH_INTERACTION_TYPE;
  });
}
function getServiceItemModifierSets(item, modifierSets) {
  var modifierSetIds = item.modifierSets;
  if ((0, _isEmpty2["default"])(modifierSetIds)) {
    return [];
  }
  return modifierSetIds.map(function (modifierSetId) {
    return modifierSets.find(function (_ref16) {
      var _id = _ref16._id;
      return _id === modifierSetId;
    });
  }).filter(Boolean);
}
function getOtherLocations(location) {
  var locations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var _ref17 = location || {},
    locationId = _ref17._id;
  return locations.filter(function (_ref18) {
    var _id = _ref18._id;
    return _id !== locationId;
  });
}
function createLocationName(_ref19) {
  var name = _ref19.name,
    street = _ref19.street,
    city = _ref19.city;
  if (!(0, _isEmpty2["default"])(name)) {
    return name;
  }
  if (!(0, _isEmpty2["default"])(street) && !(0, _isEmpty2["default"])(city)) {
    return "".concat(street, ", ").concat(city);
  }
  return street || city;
}
function getLocationTeamMembers() {
  var teamMembers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var targetLocationId = arguments.length > 1 ? arguments[1] : undefined;
  return teamMembers.filter(function (_ref20) {
    var locations = _ref20.locations;
    return locations.filter(function (_ref21) {
      var location = _ref21.location,
        merchantLocation = _ref21.merchantLocation;
      return targetLocationId === location || targetLocationId === merchantLocation;
    }).length > 0;
  });
}
function getRelatedServicesForLocation(location) {
  var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var locationId = getId(location);
  return items.filter(function (_ref22) {
    var itemLocations = _ref22.locations,
      visible = _ref22.visible;
    if (!visible) {
      return false;
    }
    return itemLocations.some(function (_ref23) {
      var itemLocationId = _ref23.location,
        displayOnLocationPage = _ref23.displayOnLocationPage;
      return locationId === itemLocationId && displayOnLocationPage;
    });
  });
}
function getTeamMemberServices() {
  var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var associatedItemVariations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  function getItemIdsWithAssociatedVariations(itemIds) {
    return itemIds.map(function (itemId) {
      var foundAssociation = associatedItemVariations.find(function (_ref24) {
        var aItemId = _ref24.itemId;
        return aItemId === itemId;
      });
      return foundAssociation ? itemId : null;
    }).filter(Boolean);
  }
  function getVariationsForAssociatedItem(associatedItem, variations) {
    return associatedItem.reduce(function (acc, _ref25) {
      var variationId = _ref25.variationId,
        overridePrice = _ref25.price;
      var variationIndex = variations.findIndex(function (_ref26) {
        var _id = _ref26._id;
        return _id === variationId;
      });
      if (variationIndex === -1) {
        return acc;
      }
      var initialPrice = variations[variationIndex].price;
      return [].concat((0, _toConsumableArray2["default"])(acc.slice(0, variationIndex)), [_objectSpread(_objectSpread({}, acc[variationIndex]), {}, {
        price: +overridePrice === 0 || overridePrice === '' ? initialPrice : overridePrice
      })], (0, _toConsumableArray2["default"])(acc.slice(variationIndex + 1)));
    }, variations);
  }
  function consolidateItemVariations(itemIds, associatedItemVariationsMap) {
    return itemIds.map(function (itemId) {
      var associatedItem = associatedItemVariationsMap[itemId];
      if ((0, _isEmpty2["default"])(associatedItem)) {
        return null;
      }
      var _head2 = (0, _head3["default"])(associatedItem),
        item = _head2.item;
      var _item$variations = item.variations,
        variations = _item$variations === void 0 ? [] : _item$variations,
        visible = item.visible,
        restItem = (0, _objectWithoutProperties2["default"])(item, _excluded2);
      if (!visible) {
        return null;
      }
      var nextVariations = getVariationsForAssociatedItem(associatedItem, variations);
      nextVariations = nextVariations.filter(function (_ref27) {
        var currentVariationId = _ref27._id;
        return associatedItem.some(function (_ref28) {
          var variationId = _ref28.variationId;
          return variationId === currentVariationId;
        });
      });
      return _objectSpread(_objectSpread({}, restItem), {}, {
        variations: nextVariations
      });
    }).filter(Boolean);
  }
  return categories.map(function (_ref29) {
    var items = _ref29.items,
      restCategory = (0, _objectWithoutProperties2["default"])(_ref29, _excluded3);
    var itemIdsWithVariationOverrides = getItemIdsWithAssociatedVariations(items);
    var itemVariationOverridesMap = (0, _groupBy2["default"])(associatedItemVariations, 'itemId');
    var itemsWithConsolidatedVariations = consolidateItemVariations(itemIdsWithVariationOverrides, itemVariationOverridesMap);
    if (itemsWithConsolidatedVariations.length === 0) {
      return null;
    }
    return _objectSpread(_objectSpread({}, restCategory), {}, {
      items: itemsWithConsolidatedVariations
    });
  }).filter(Boolean);
}
function createVariationShortDescription(_ref30) {
  var shortDescription = _ref30.shortDescription,
    duration = _ref30.duration,
    durationUnit = _ref30.durationUnit;
  if (!(0, _isNil2["default"])(duration) && !(0, _isEmpty2["default"])(shortDescription)) {
    return "".concat(shortDescription, " (Duration: ").concat(duration, " ").concat(durationUnit, ").");
  }
  if (!(0, _isEmpty2["default"])(shortDescription)) {
    return shortDescription;
  }
  if (!(0, _isNil2["default"])(duration)) {
    return "Duration: ".concat(duration, " ").concat(durationUnit, ".");
  }
  return '';
}
function getServiceTeamMembers(serviceItem, teamMembers) {
  var _ref31 = serviceItem || {},
    serviceItemId = _ref31._id;
  return (teamMembers || []).filter(function (_ref32) {
    var associatedItemVariations = _ref32.associatedItemVariations;
    var matchedItem = (associatedItemVariations || []).find(function (_ref33) {
      var itemId = _ref33.itemId,
        item = _ref33.item;
      return "".concat(serviceItemId) === "".concat(itemId) || "".concat(serviceItemId) === "".concat((0, _get2["default"])(item, '_id'));
    });
    return !(0, _isEmpty2["default"])(matchedItem);
  });
}
function getComponentContentNodeContent(_ref34) {
  var components = _ref34.components,
    componentName = _ref34.componentName,
    componentId = _ref34.componentId,
    _ref34$defaultValue = _ref34.defaultValue,
    defaultValue = _ref34$defaultValue === void 0 ? '' : _ref34$defaultValue,
    _ref34$selectFirst = _ref34.selectFirst,
    selectFirst = _ref34$selectFirst === void 0 ? true : _ref34$selectFirst;
  if ((0, _isEmpty2["default"])(components || (0, _isEmpty2["default"])(componentId))) {
    return defaultValue;
  }
  var foundComponents = components.filter(function (_ref35) {
    var fastId = _ref35.fastId,
      componentIdentifier = _ref35.componentIdentifier;
    if ((0, _isEmpty2["default"])(componentName)) {
      return componentIdentifier === componentId;
    }
    return fastId === componentName && componentIdentifier === componentId;
  });
  if ((0, _isEmpty2["default"])(foundComponents)) {
    return defaultValue;
  }
  if (!selectFirst && foundComponents.length > 1) {
    return defaultValue;
  }
  var foundComponent = foundComponents[0];
  var _ref36 = foundComponent || {},
    _ref36$contentNodes = _ref36.contentNodes,
    contentNodes = _ref36$contentNodes === void 0 ? [] : _ref36$contentNodes;
  if ((0, _isEmpty2["default"])(contentNodes)) {
    return defaultValue;
  }
  if (!selectFirst && contentNodes.length > 1) {
    return defaultValue;
  }
  var contentNode = contentNodes[0];
  var _ref37 = contentNode || {},
    _ref37$content = _ref37.content,
    content = _ref37$content === void 0 ? '' : _ref37$content;
  return content || '';
}
function filterBookingInteractions() {
  var interactions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return interactions.filter(function (_ref38) {
    var role = _ref38.role;
    return role === _constants.INTERACTION_ROLE_BOOKING;
  });
}